import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, reduxForm} from 'redux-form';
import {Badge, Button, ButtonGroup, ButtonToolbar, Card as Panel, Col, Form, FormCheck as Checkbox, FormGroup, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {findUsers} from '../../actions/users';
import {CheckboxField, DateField, FileField, formatDate, ImageField, scrollToErrors, SelectField, TextareaField, TextField} from '../form/form';
import {Acl, Date, Enums, Files} from "../../utils";
import placeholder from '../../resources/images/placeholder.png';

// const validateAddError = (errors, key, i, name, error) => {
// 	if (!errors[key]) {
// 		errors[key] = {}
// 	}
// 	if (!errors[key][i]) {
// 		errors[key][i] = {}
// 	}
// 	errors[key][i][name] = error
// };

const validateBirthNumber = (value, values) => {

	const birthNumber = value ? value.replace('/', '') : "";
	if (birthNumber.length < 9 || birthNumber.length > 10) {
		return -1
	}

	const suffixLen = birthNumber.length < 10 ? 3 : 4;
	const p1 = birthNumber.substr(0, 6);
	const p2 = birthNumber.substr(-suffixLen);

	if (("000000" + (p1 * 1)).substr(-6) !== p1) {
		return -2
	}
	if (((suffixLen >= 4 ? "0000" : "000") + (p2 * 1)).substr(-suffixLen) !== p2) {
		return -3
	}

	const y2 = 1 * p1.substr(0, 2);
	if (suffixLen < 4 && y2 >= 65) {
		return -4
	}

	if (suffixLen >= 4) {
		const mod = (1 * birthNumber.substr(0, 9)) % 11;
		const lastNum = 1 * birthNumber.substr(-1);
		if (mod === 10) {
			if (lastNum !== 0) {
				return -5
			}
		} else if (lastNum !== mod) {
			return -6
		}
	}

	let y = y2;
	if (suffixLen < 4) {
		y += 1900
	} else if (y > 20) {
		y += 1900;
	} else {
		y += 2000;
	}

	const m2 = 1 * p1.substr(2, 2);
	let m = m2;
	if (m2 > 70 && y > 2003) {
		m -= 70;
	} else if (m2 > 50) {
		m -= 50;
	} else if (m2 > 20 && y > 2003) {
		m -= 20;
	}

	if (m < 1 || m > 12) {
		return -7
	}

	const d = 1 * p1.substr(4, 2);
	if (d < 1 || d > 31) {
		return -8
	}

	if (values) {
		values.birthDate = ("00" + d).substr(-2) + "." + ("00" + m).substr(-2) + "." + y;
		values.birthNumber = p1 + '/' + p2;
		values.sex = m2 > 50 ? 'F' : 'M'
	}
	return 1
};

// const sexOptions = [
// 	{label: 'Muž', value: 'M'},
// 	{label: 'Žena', value: 'F'}];
//
const validate = (values, b, c) => {
	const errors = {};
	if (!values.lastName) {
		errors.lastName = 'Zadejte prosím příjmení'
	}
	if (!values.firstName) {
		errors.firstName = 'Zadejte prosím jméno'
	}
	// if (!values.countryCode) {
	// 	errors.countryCode = 'Vyberte prosím stát'
	// } else if (values.countryCode === 'CZE' && !values.birthNumber && Acl.hasAction(values, Acl.user.EDIT_RESTRICTED)) {
	// 	errors.birthNumber = 'Zadejte prosím RČ'
	// }
	if (!values.sex) {
		errors.sex = 'Zvolte prosím pohlaví'
	}

	if (values.roleId && !values.email) {
		errors.email = 'Zadejte prosím email'
	} else if (values.email && (values.email.indexOf('@') <= 0 || values.email.length < 5)) {
		errors.email = 'Neplatný email'
	}

	if (values.birthNumber) {
		let r = validateBirthNumber(values.birthNumber);
		if (r < 0) {
			errors.birthNumber = 'Neplatné rodné číslo'
		}
	}
	if (values.birthDate && values.birthDate.length >= 4) {
		if (1 * values.birthDate.substr(-4) > 2017) {
			errors.birthDate = 'Neplatné datum narození'
		}
	}

	return errors
};

const asyncValidate = (values, dispatch, props, currentFieldName) => {
	if (!currentFieldName || !values[currentFieldName]) {
		return new Promise((resolve, reject) => resolve())
	}
	const filter = {};
	const errors = Object.assign({}, props.asyncErrors);
	filter[currentFieldName] = values[currentFieldName].trim();
	return new Promise((resolve, reject) => {
		dispatch(findUsers(filter))
			.then((json) => {
				if (json.response) {
					let found = false;
					if (json.response.data) {
						for (let k in json.response.data) {
							if (json.response.data.hasOwnProperty(k)) {
								if (!values.personalId || json.response.data[k].personalId !== values.personalId) {
									found = json.response.data[k].personalId;
									break
								}
							}
						}
					}
					if (found) {
						errors[currentFieldName] = "Člen již existuje (" + found + ")";
						reject(errors)
					} else {
						resolve({})
					}
				} else {
					errors[currentFieldName] = "Nepodařilo se ověřit unikátnost";
					reject(errors)
				}

			})
			.catch(err => {
				errors[currentFieldName] = "Nepodařilo se ověřit unikátnost (" + err + ")";
				reject(errors)
			})

	})
};

class UserForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			changeStatus: false,
			eligibleCategories: {
				filter: {}
			}
		};

		this.handleChangeStatusClick = this.handleChangeStatusClick.bind(this);
		this.renderYesNo = this.renderYesNo.bind(this);

		this.handleSexChange = this.handleSexChange.bind(this);
		this.handleBirthNumberChange = this.handleBirthNumberChange.bind(this);
		this.handleBirthDateChange = this.handleBirthDateChange.bind(this);
	}

	componentDidMount() {
		// this.props.onFetchEnums(["countries", "clubs", "roles"]);
		this.syncEnumsAndState(this.props)
	}

	componentDidUpdate(prevProps) {
		if (this.props.initialValues && this.props.initialValues.userId !== (prevProps.initialValues ? prevProps.initialValues.userId : null)) {
			this.syncEnumsAndState(this.props)
		}
	}

	syncEnumsAndState(nextProps) {
	}

	handleSexChange(event) {
		// const sex = event.target.value
		// if (sex) {
		// 	this.refreshEligibleCategories(
		// 		this.state.eligibleCategories.filter.birthNumber,
		// 		this.state.eligibleCategories.filter.birthDate,
		// 		sex)
		// } else {
		// 	this.refreshEligibleCategories(
		// 		this.state.eligibleCategories.filter.birthNumber,
		// 		this.state.eligibleCategories.filter.birthDate,
		// 		null)
		// }
	}

	handleBirthNumberChange(event) {
		const value = event.target.value;
		const values = {};
		if (value && validateBirthNumber(value, values) > 0) {
			this.props.change('birthDate', values.birthDate);
			this.props.change('sex', values.sex);

			// this.refreshEligibleCategories(
			// 	values.birthNumber,
			// 	values.birthDate,
			// 	values.sex)
		} else {
			// this.refreshEligibleCategories(
			// 	null,
			// 	this.state.eligibleCategories.filter.birthDate,
			// 	this.state.eligibleCategories.filter.sex)
		}
	}

	handleBirthDateChange(event) {
		// const birthDate = event.target.value;
		// if (birthDate && birthDate.length >= 4) {
		// 	this.refreshEligibleCategories(
		// 		this.state.eligibleCategories.filter.birthNumber,
		// 		birthDate,
		// 		this.state.eligibleCategories.filter.sex)
		// } else {
		// 	this.refreshEligibleCategories(
		// 		this.state.eligibleCategories.filter.birthNumber,
		// 		null,
		// 		this.state.eligibleCategories.filter.sex)
		// }
	}

	handleChangeStatusClick() {
		this.setState({changeStatus: !this.state.changeStatus})
	}

	renderYesNo(key, value = null, disabled = false, user = null) {
		const checked = value ? (this.state[key] && this.state[key].indexOf(value) >= 0) : this.state[key];
		return <ButtonGroup data-toggle="buttons" className="pull-right">
			<label className={"btn btn-sm " + (!!checked ? "btn-success" : "btn-default") + (disabled ? " disabled" : "")}>
				Ano
				<input type="checkbox" disabled={disabled} onChange={(e) => {
					const s = Object.assign(this.state);
					if (value) {
						s[key].push(value)
					} else {
						s[key] = true
					}
					this.setState(s)
				}}/>
			</label>
			<label className={"btn btn-sm " + (!checked ? "btn-danger" : "btn-default") + (disabled ? " disabled" : "")}>
				Ne
				<input type="checkbox" disabled={disabled} onChange={(e) => {
					const s = Object.assign(this.state);
					if (value) {
						s[key] = s[key].filter((v, i) => v !== value)
					} else {
						s[key] = false
					}
					this.setState(s)
				}}/>
			</label>
		</ButtonGroup>
	}

	render() {
		const {handleSubmit, initialValues, submitting, enums, onSaveUser, onDeleteUser, session} = this.props;
		const noRestricted = !Acl.hasAction(initialValues, Acl.user.EDIT_RESTRICTED);
		const noFull = !Acl.hasAction(initialValues, Acl.user.EDIT_FULL)

		const statusOptions = [];
		if (initialValues.status === 'DELETED') {
			statusOptions.push({label: 'Ukončená činnost', value: 'DELETED'})
		} else {
			statusOptions.push({label: 'Nepotvrzený', value: 'NEW'});
			statusOptions.push({label: 'Potvrzený', value: 'ACTIVE'})
		}
		const allRoles = Enums.createEnumItems(enums, Enums.getKey("roles"), true);
		const roleOptions = [];
		for (let i = 0; i < allRoles.length; i++) {
			if (noFull && allRoles[i].label !== 'Admin klubu' && allRoles[i].label !== 'Člen' && initialValues.roleId !== allRoles[i].value) {
				continue
			}
			roleOptions.push(allRoles[i])
		}

		return (
			<Form horizontal onSubmit={handleSubmit((values) => {
				return onSaveUser(values)
			})} className="detail">
				<Row>
					<Col lg={6}>
						<Panel header={<span>Člen
							{Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL) && initialValues.personalId && initialValues.personalId.indexOf('CZ') >= 0 &&
							<ButtonGroup className="pull-right" style={{marginLeft: "10px"}}>
								<Button type="button" className="btn-sm" onClick={() => this.handleRacerLicenceOpenClick('member')}><span className="fa fa-eye-open"/> Průkaz</Button>&nbsp;
							</ButtonGroup>}
							{initialValues.personalId ? <Badge className="pull-right">ID {initialValues.personalId}</Badge> : null}</span>}>
							<Row>
								<Col xs={6}>
									<Field label='Příjmení' name="lastName" type='text' component={TextField} maxLength="100" disabled={noRestricted}/>
									<Field label='Jméno' name="firstName" type='text' component={TextField} maxLength="100" disabled={noRestricted}/>
									{/*<Field label="Stát" name="countryCode" type="select" component={SelectField} disabled={noRestricted}*/}
									{/*options={Enums.createEnumItems(enums, Enums.getKey("countries"))}*/}
									{/*clearable={false}/>*/}
									{/*<Field label="Pohlaví" name="sex" type="radio" options={sexOptions} component={RadioField} disabled={noRestricted}*/}
									{/*	onChangeHook={this.handleSexChange}/>*/}
								</Col>
								<Col xs={4} xsOffset={2}>
									<Field label="Fotografie" name="photo" type='file' component={ImageField}
										buttonLabel="Nahrát foto"
										imgTitle="Fotografie bude uložena"
										imgSrc={initialValues.photoGuid ? Files.getLink(initialValues.photoGuid) : placeholder}/>
								</Col>
							</Row>
							<Row>
								<Col xs={6}>
									<Field label="RČ" name="birthNumber" type='text' component={TextField} maxLength="11" disabled={noRestricted} feedbackSuccess
										onChangeHook={this.handleBirthNumberChange} normalize={(value) => {
										const values = {};
										if (validateBirthNumber(value, values) > 0) {
											return values.birthNumber
										}
										return value
									}}/>
									<Field label="Dat. nar." name="birthDate" type='text' component={TextField} maxLength="10" disabled={noRestricted}
										onChangeHook={this.handleBirthDateChange} placeholder="DD.MM.RRRR"/>
								</Col>
								<Col xs={6}>
									<Field label="Titul před" name="titleBefore" type='text' component={TextField} maxLength="10"/>
									<Field label="Titul za" name="titleAfter" type='text' component={TextField} maxLength="10"/>
								</Col>
							</Row>
							<Row className="divider">
								{/*<Col xs={6}>*/}
								{/*<Field label="Klub" name="clubId" type="select" component={SelectField}*/}
								{/*disabled={noFull && !(initialValues.personalId === null && Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL))}*/}
								{/*options={Enums.createEnumItems(enums, Enums.getKey("clubs"), true)}/>*/}
								{/*<Field label="Funkce" name="clubRole" type='text' component={TextField} maxLength="30"/>*/}
								{/*</Col>*/}
								<Col xs={6}>
									{/*<Field label="Oprávnění" name="roleId" type="select" component={SelectField} emptyText="Člen"*/}
									{/*options={roleOptions}/>*/}
									<Field label="Kontaktní osoba klubu" name="isContact" type='checkbox' component={CheckboxField}/>
								</Col>
							</Row>
							<Row className="divider">
								<Col xs={6}>
									<Field label="Stav" name="status" type="select" component={SelectField} options={statusOptions} disabled={noFull}/>
									{Acl.hasAction(initialValues, Acl.user.DEACTIVATE) && <FormGroup>
										<Col smOffset={4} sm={8}>
											<Checkbox id="changeStatus" checked={this.state.changeStatus} onChange={this.handleChangeStatusClick}>
												{initialValues.status === 'DELETED' ? 'Obnovení činnosti' : 'Ukončení činnosti'}</Checkbox>
										</Col>
									</FormGroup>}
									{this.state.changeStatus
									&& <Field label="K datu" name={initialValues.status === 'DELETED' ? "dateActive" : "dateArchive"} type='date'
										maxDate={Date.today(session)} component={DateField} maxLength="12" format={formatDate}/>}
								</Col>
								<Col xs={6}>
									<Field label="Přihláška" name="application" type='file' component={FileField} disabled={noRestricted}
										buttonLabel="Nahrát"
										fileTitle="Přihláška bude uložena"
										fileSrc={initialValues.applicationGuid ? Files.getLink(initialValues.applicationGuid) : false}/>
								</Col>
							</Row>
						</Panel>
						<Panel header="Kontaktní informace">
							<Row>
								<Col xs={6}>
									<Field label="Město" name="city" type='text' component={TextField} maxLength="30"/>
									<Field label="Ulice" name="street" type='text' component={TextField} maxLength="30"/>
									<Field label="PSČ" name="zip" type='text' component={TextField} maxLength="6"/>
								</Col>
								<Col xs={6} className="extended-fields">
									<Field label="Telefon" title="Pevná linka" name="landPhone" type='text' component={TextField} maxLength="30"/>
									<Field label="Mobil" name="phone" type='text' component={TextField} maxLength="30"/>
									<Field label="E-mail" name="email" type='text' component={TextField} maxLength="100" feedbackSuccess/>
								</Col>
							</Row>
							<Row>
								<Col xs={12}>
									<Field label="Poznámka" name="note" type='textarea' component={TextareaField} maxLength="255"/>
								</Col>
							</Row>
						</Panel>
					</Col>

					<Col lg={6}>
						<Panel header={<span>Závodník {this.renderYesNo('isRacer', null, false, initialValues)} {Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL) && initialValues.personalId &&
						<ButtonGroup className="pull-right">
							<Button type="button" className="btn-sm" onClick={() => this.handleRacerLicenceOpenClick('racer')}><span className="fa fa-eye-open"/> Licence</Button>&nbsp;
						</ButtonGroup>}</span>}>
							<div>
								<Row>
									<Col xs={6}>
										<Field label="Prohlídka" name="birthDate" type='date' maxDate={Date.today(session)} component={DateField} maxLength="12" format={formatDate} disabled={false}/>
									</Col>
									<Col xs={6}>
									</Col>
								</Row>
							</div>
						</Panel>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<ButtonToolbar className="text-center">
							<Link to={{pathname: "/users" + (initialValues.userId ? "/" + initialValues.userId : "")}} className="btn btn-default"><span className="fa fa-remove"/> Storno</Link>
							{Acl.hasAction(initialValues, Acl.user.DELETE) &&
							<Button variant="danger" type="button" disabled={submitting} onClick={() => onDeleteUser(initialValues)}><span className="fa fa-trash"/> Smazat</Button>}
							<Button variant="success" type="submit" disabled={submitting}><span className="fa fa-ok"/> {initialValues.userId ? "Uložit změny" : "Založit člena"}</Button>
						</ButtonToolbar>
					</Col>
				</Row>
			</Form>
		)
	}
}

UserForm = reduxForm({
	form: 'user',
	validate,
	asyncValidate,
	onSubmitFail: scrollToErrors,
	asyncBlurFields: ['birthNumber', 'email']
})(UserForm);

UserForm.propTypes = {
	id: PropTypes.number,
	item: PropTypes.object.isRequired,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onSaveUser: PropTypes.func.isRequired,
	onDeleteUser: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default UserForm
